module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 1.76f7b2f6.png";